<template>
  <v-flex>
    <v-container fluid class="pl-0">
      <p class="radio-title">{{ label }}</p>
      <v-checkbox
        v-for="item in items"
        v-model="selected"
        color="secondary"
        class="checkbox-group"
        :label="item"
        :value="item"
        hide-details
        @change="$emit('input', selected)"
        @blur="validator && validator.$touch()"
      />
    </v-container>
    <p v-if="getErrors(validator)" class="error--text pl-3 error-font-size"> {{ getErrors(validator)[0] }}</p>
  </v-flex>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { defaultMessages, getValidationErrors } from '@/utils'

export default {
  mixins: [AdminContext],
  name: 'checkbox-group',
  props: {
    label: {
      type: String,
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemRender: {
      type: String,
      default: null,
    },
    itemSelect: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      selected: this.value,
    }
  },
  watch:{
    value(val){
      this.selected=val
    },
  },
  methods: {
    getErrors: function(field){
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.adminFieldValidationMessages(this.errorMessages),
      })(field)
    },
  },
}
</script>

<style scoped>
.radio-title {
  font-size: 16px;
  line-height: 20px;
  color: #979797;
  font-weight: bold;
  margin-bottom: 12px;
}
.checkbox-group {
  font-size: 14px;
  line-height: 18px;
  margin-top: 8px;
}
.error-font-size {
  font-size: 12px;
}

</style>
